import gettext from '@sdk/lang/gettext';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';
import Avatar from '@sdk/components/avatar/Avatar';

import { getUserFormattedGroups } from '@web/common/utils/getUserFormattedGroups';
import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';
import { EmptyAnnouncementViews } from '@web/announcements/EmptyAnnouncementViews/EmptyAnnouncementViews';
import { useScrollbarGutterFallback } from '@web/common/hooks/useScrollbarGutterFallback';

import { ViewerSkeleton } from './components/ViewerSkeleton';
import { useAnnouncementViewers } from './announcementViews.hooks';
import {
  IconWrapper,
  InnerWrapper,
  ItemAvatar,
  ItemMeta,
  ItemName,
  List,
  ListItem,
  ListItemSkeleton,
  ScrollContainer,
  Wrapper,
} from './announcementViews.styles';

type Props = {
  id: number;
  onClose: () => void;
};

export const AnnouncementViews = ({ id, onClose }: Props) => {
  const { hasEmptyData, isLoading, viewers } = useAnnouncementViewers({ id });
  const { setRef, shouldApplyFallback } = useScrollbarGutterFallback();

  return (
    <Wrapper>
      <InfoModal
        buttonsPadding={0}
        fullScreen
        titleText={gettext('Seen by')}
        titleIcon={
          <IconWrapper>
            <ExclamationMarkIcon aria-hidden={true} />
          </IconWrapper>
        }
        buttonText={gettext('Close')}
        dismiss={onClose}
        zIndex={1045}>
        <InnerWrapper>
          <ScrollContainer ref={setRef} shouldApplyFallback={shouldApplyFallback}>
            {hasEmptyData ? (
              <EmptyAnnouncementViews />
            ) : (
              <List>
                {isLoading ? (
                  <>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                    <ListItemSkeleton>
                      <ViewerSkeleton />
                    </ListItemSkeleton>
                  </>
                ) : (
                  viewers.map((viewer) => (
                    <ListItem key={viewer.id}>
                      <ItemAvatar>
                        <Avatar user={viewer} />
                      </ItemAvatar>
                      <ItemName>{viewer.fullname}</ItemName>
                      <ItemMeta>{getUserFormattedGroups(viewer)}</ItemMeta>
                    </ListItem>
                  ))
                )}
              </List>
            )}
          </ScrollContainer>
        </InnerWrapper>
      </InfoModal>
    </Wrapper>
  );
};
